export var designApiRelativePath = "/helpcenter/appearance/design";
export var createDesignApi = function (baseUrl, http) {
    var apiUrl = "" + baseUrl + designApiRelativePath;
    return {
        getDesign: function () { return http.get("" + apiUrl); },
        updateDesign: function (dto) {
            return http.put("" + apiUrl, dto.data);
        }
    };
};
//# sourceMappingURL=index.js.map